import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "submitElement", "hasIcon", "onSubmit", "onChange", "data-test", "kind", "value"];

/* eslint-disable react/jsx-no-duplicate-props */
import React from 'react';
import PropTypes from 'prop-types';
import { SearchIcon } from '@sainsburys-tech/bolt-icons';
import * as Styled from './SearchBar.styles';

function SearchBar(_ref) {
  var _React$createElement;

  var className = _ref.className,
      submitElement = _ref.submitElement,
      hasIcon = _ref.hasIcon,
      onSubmit = _ref.onSubmit,
      onChange = _ref.onChange,
      dataTest = _ref['data-test'],
      _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? 'primary' : _ref$kind,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      props = _objectWithoutProperties(_ref, _excluded);

  var submitSearchTerm = function submitSearchTerm(evt) {
    evt.preventDefault();
    onSubmit(value);
  };

  return /*#__PURE__*/React.createElement(Styled.SearchBar, {
    className: className,
    "data-test": dataTest,
    onSubmit: submitSearchTerm
  }, /*#__PURE__*/React.createElement(Styled.SearchInput, _extends({
    type: "text",
    "aria-label": "Search",
    value: value,
    onChange: onChange,
    name: "search",
    autoComplete: "false"
  }, props)), /*#__PURE__*/React.createElement(Styled.ButtonContainer, null, /*#__PURE__*/React.createElement(Styled.SearchButton, (_React$createElement = {
    type: "submit",
    kind: "primary",
    value: "Submit"
  }, _defineProperty(_React$createElement, "kind", kind), _defineProperty(_React$createElement, "data-test", "".concat(dataTest, "-search-button")), _React$createElement), hasIcon ? /*#__PURE__*/React.createElement(Styled.SearchIconContainer, null, /*#__PURE__*/React.createElement(SearchIcon, {
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Search Button")) : submitElement)));
}

SearchBar.displayName = 'SearchBar';
SearchBar.propTypes = {
  /**
   * Specify an optional className to be added to your Search Bar
   */
  className: PropTypes.string,

  /**
   * Specify an optional data-test attribute to be added to your Search Bar for e2e testing
   */
  'data-test': PropTypes.string,

  /**
   * Specify the submit callback function
   */
  onSubmit: PropTypes.func.isRequired,

  /**
   * Specify a mandatory callback for the input field's onChange event
   */
  onChange: PropTypes.func,

  /**
   * Display search icon instead of submitElement
   */
  hasIcon: PropTypes.bool,

  /**
   * Specify the content of your submit element
   */
  value: PropTypes.string,

  /**
   * Specify the content of the submitElement
   */
  submitElement: PropTypes.node,

  /**
   * Specify the value of the placeholder
   */
  placeholder: PropTypes.string,

  /**
   * Specify kind of search bar button
   */
  kind: PropTypes.oneOf(['primary', 'secondary'])
};
SearchBar.defaultProps = {
  hasIcon: false,
  submitElement: 'Search',
  placeholder: '',
  kind: 'primary',
  onSubmit: function onSubmit() {},
  onChange: function onChange() {},
  'data-test': 'component-searchbar'
};
export default SearchBar;